export default "__VITE_ASSET__BDmf$O34__"